module.exports = __webpack_public_path__ + "static/media/bath.e19c2000.svg";